import { Composition, Folder } from "remotion";
import { HelloWorld } from "./HelloWorld";
import { Logo } from "./HelloWorld/Logo";
import { Title } from "./HelloWorld/Title";
import { InstagramVideo } from "./InstagramVideo";
import LauraBrianMirrorCinematic from "./LauraBrianMirrorCinematic";
import { MediaTest } from "./MediaTest";
import {
  HyperframesImport,
  calculateHyperframesMetadata,
  hyperframesImportDefaultProps,
} from "./HyperframesImport";
import { AksharIslandDecalReel } from "./AksharIslandDecalReel";

// Each <Composition> is an entry in the sidebar!

export const RemotionRoot: React.FC = () => {
  return (
    <>
      <Folder name="Elements">
        <Composition
          id="Logo"
          component={Logo}
          durationInFrames={150}
          fps={30}
          width={1920}
          height={1080}
          defaultProps={{
            logoColor1: "#91EAE4",
            logoColor2: "#86A8E7",
          }}
        />
        <Composition
          id="Title"
          component={Title}
          durationInFrames={115}
          fps={30}
          width={1920}
          height={1080}
          defaultProps={{
            titleText: "Welcome to Remotion",
            titleColor: "#000000",
          }}
        />
      </Folder>
      <Composition
        // You can take the "id" to render a video:
        // bunx remotion render HelloWorld
        id="HelloWorld"
        component={HelloWorld}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
        // You can override these props for each render:
        // https://www.remotion.dev/docs/parametrized-rendering
        defaultProps={{
          titleText: "Welcome to Remotion",
          titleColor: "#000000",
        }}
      />
      <Composition
        id="AksharCreationsReel"
        component={InstagramVideo}
        durationInFrames={450}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="LauraBrianMirrorCinematic"
        component={LauraBrianMirrorCinematic}
        durationInFrames={600}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="MediaTest"
        component={MediaTest}
        durationInFrames={150}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="HyperframesImport"
        component={HyperframesImport}
        calculateMetadata={calculateHyperframesMetadata}
        durationInFrames={180}
        fps={30}
        width={1080}
        height={1920}
        defaultProps={hyperframesImportDefaultProps}
      />
      <Composition
        id="AksharIslandDecalReel"
        component={AksharIslandDecalReel}
        durationInFrames={540}
        fps={30}
        width={1080}
        height={1920}
      />

    </>
  );
};
